import Abstract from '../../framework/Abstract';
import Slider from '../../framework/Slider';

import './B11-feature-cards.scss';

class B11FeatureCards extends Abstract {
	init() {
		this.setupObjectFit();

		const sliderEl = this.root.querySelector('.swiper-container');
		const nextEl = this.root.querySelector('.swiper-button-next');
		const prevEl = this.root.querySelector('.swiper-button-prev');

		this.slider = new Slider(sliderEl, {
			speed: 500,
			slidesPerView: 4,
			navigation: {
				nextEl,
				prevEl,
			},
			breakpoints: {
				// when window width is <= 576px
				576: {
					slidesPerView: 'auto',
				},
				// when window width is <= 768px
				992: {
					slidesPerView: 2,
				},
			},
			simulateTouch: false,
		});
	}
}

export default B11FeatureCards;
